"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Clone object without given keys.
 *
 * @Param {Object} object = Object to clone.
 * @Param {...String}     = Subset of keys in object to remove.
 *
 * @Example
 *
 *   except({ snack: 'banana', dish: 'pizza' }, 'snack')
 *   //=> { dish: 'pizza' }
 */
function except(obj, ...keys) {
    return keys.reduce((newObj, key) => {
        const _a = key, value = newObj[_a], rest = __rest(newObj, [typeof _a === "symbol" ? _a : _a + ""]);
        return rest;
    }, obj);
}
exports.except = except;
//# sourceMappingURL=except.js.map